// extracted by mini-css-extract-plugin
export default {"iconContainer":"icon_iconContainer__vNMLB","box":"icon_box__qT7Db","iconSvg":"icon_iconSvg__Z0iZz","pointer":"icon_pointer__qXRBG"};